module.exports = __webpack_public_path__ + "static/Syberia3-2f8c6aba255ef9d5608e46b52c46d971.png";